import { createStaticReducer } from '../../../../packages/redux-utils';
import { IExperiment } from '../../types/experiments';

const defaultState: IExperiment[] = [];

export const experimentsReducer = createStaticReducer<IExperiment[]>(defaultState);
